export default __webpack_public_path__ + "static/media/TonicPrizes.73f079834f0f20c7c27f94583cadee64.webp";